import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';

export interface FilterPanelProps {
  title?: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  className?: string;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  title = 'Filters',
  children,
  collapsible = false,
  defaultExpanded = true,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`bg-white/80 backdrop-blur rounded-xl shadow border border-monday-border-light ${className}`}>
      <div className="px-4 py-5 sm:px-6">
        {title && (
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg leading-6 font-semibold tracking-tight text-monday-text">{title}</h3>
            {collapsible && (
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="p-1 rounded-lg text-monday-text-muted hover:text-monday-text hover:bg-monday-header transition-colors"
                aria-label={isExpanded ? 'Collapse filters' : 'Expand filters'}
              >
                {FiIcons.FiChevronDown({
                  className: `h-5 w-5 transition-transform duration-200 ${isExpanded ? '' : '-rotate-90'}`
                })}
              </button>
            )}
          </div>
        )}
        {(!collapsible || isExpanded) && (
          <div className="mt-4">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;
